export enum VarianceFormulaBaselineType {
    Old,
    New,
    Canonical,
}

export class VarianceFormulaBaseLine {
    public type: VarianceFormulaBaselineType;
    public formCompSeq: number[] | null;
}